import RadioTabGroup from './RadioTabGroup';

export default RadioTabGroup;
